// Alert.tsx
import React from 'react';
import styles from './Alert.module.css';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';



interface AlertProps {
    title: string;
    message: string;

    onClose?: () => void;
}
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        minHeight: "100px",
        maxHeight: "80vh", // Better for different screen sizes
        minWidth: "50px",       // won't shrink below this
        maxWidth: "500px",        // won't grow beyond 90% viewport width
        right: 'auto',
        height: "auto",      // Let content determine initial height
        marginRight: '-50%',
        alignItems: 'center',
        overflow: 'auto',
        justifyContent: 'space-between',
        transform: 'translate(-50%, -50%)',
        borderRadius: "20px",

    },
};
const Alert: React.FC<AlertProps> = ({
    message,
    title,
    onClose
}) => {
    const { t, i18n } = useTranslation();
    return (

        <Modal
            isOpen={true}
            onRequestClose={onClose}
            style={customStyles}
        >
            <div className={styles.modalContent}>

                <h2 className={`${styles.title} ${i18n.language === 'ar' ? styles.arabic : ''
                    }`}>{title}</h2>
                <p className={`${styles.message} ${i18n.language === 'ar' ? styles.arabic : ''
                    }`}>{message}</p>

                <div className={styles.modalFooter}>
                    <button className={styles.submitButton} onClick={onClose}>{t('dismiss')}</button>
                </div>
            </div>
        </Modal>


    );
};

export default Alert;